import { createApp, watch } from 'vue';
import { createPinia } from 'pinia';
import { router } from './routes';

import * as echarts from 'echarts';
import App from './App.vue';
import globalComponents from './components/global';

import PrimeVue from 'primevue/config';
import { definePreset } from '@primevue/themes';
import PrimeVueConfig from './helpers/PrimeVueConfig';
import Aura from '@primevue/themes/aura';
import ToastService from 'primevue/toastservice';
import StyleClass from 'primevue/styleclass';
import Tooltip from 'primevue/tooltip';
import FocusTrap from 'primevue/focustrap';
import ConfirmationService from 'primevue/confirmationservice';
import './assets/styles/tailwind.css';
import 'primeicons/primeicons.css';
import './assets/layout/layout.scss';
import './assets/styles/main.css';

import i18n from './locales/i18n';
const { t, locale } = i18n.global;

const myThemePresets = definePreset(Aura, PrimeVueConfig);

const app = createApp(App);

app.use(ConfirmationService);
app.use(ToastService);
app.use(i18n);
app.use(createPinia());
app.use(router);
app.use(globalComponents);
app.directive('tooltip', Tooltip);
app.directive('focustrap', FocusTrap);
app.use(PrimeVue, {
    theme: {
        preset: myThemePresets,
        options: {
            darkModeSelector: '.app-dark',
        },
    },
    locale: {
        apply: t('global.apply'),
        clear: t('global.clear'),
    },
    ripple: true,
});

app.directive('styleclass', StyleClass);
app.mount('#app');
